import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import MuiRadio, { RadioProps as MuiRadioProps } from '@mui/material/Radio';
import MuiRadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material/RadioGroup';

import { Box } from './Box';

interface RadioGroupOption {
  label: string | React.ReactNode;
  value: any;
  sx?: MuiRadioProps['sx'];
}

export interface RadioGroupProps extends MuiRadioGroupProps {
  options: RadioGroupOption[];
  label: string | React.ReactNode;
}

/**
 *
 */
export const RadioGroup: React.FC<RadioGroupProps> = ({ ...props }) => {
  const { label, options, sx } = props;
  return (
    <FormLabel sx={sx}>
      {label && <Box sx={{ mb: 2 }}>{label}</Box>}
      <MuiRadioGroup sx={{ gap: 2 }} {...props}>
        {options &&
          options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              label={option.label}
              sx={option.sx}
              control={<MuiRadio />}
            />
          ))}
      </MuiRadioGroup>
    </FormLabel>
  );
};
